<template>
  <div>
    <span
      style="margin-left: 1.5em; margin-right: 3em; fontsize: 14px; margin-bottom: 1em"
      class="has-text-grey"
    >
      {{ setting.label || name }}
    </span>
    <Tooltip :label="setting.label || name" :content="setting.detail" />
    <el-transfer
      style="display: inline-block; margin-left: 1.5em"
      v-model="value[name]"
      :titles="setting.titles"
      :data="setting.data"
      target-order="push"
      :filterable="true"
    ></el-transfer>
  </div>
</template>

<script>
/**
 * Transfer SmartField - Renders a dual-list transfer panel for array configuration values.
 *
 * @component
 * @description Displays a transfer component with two panels (available and selected items).
 * Users can move items between panels to build a list of selected values. Supports filtering
 * to quickly find items in large lists. Selected items are pushed to the end of the list.
 *
 * @prop {Object} value - Parent object containing the setting value
 * @prop {Object} setting - Field configuration object
 * @prop {string} [setting.label] - Display label for the transfer (defaults to name)
 * @prop {string} [setting.detail] - Tooltip text explaining the setting
 * @prop {Array<string>} [setting.titles] - Titles for the two panels (e.g., ['Available', 'Selected'])
 * @prop {Array<Object>} setting.data - Array of available items
 * @prop {string|number} setting.data[].key - Unique key for the item
 * @prop {string} setting.data[].label - Display label for the item
 * @prop {Array} [setting.default] - Default array of selected keys if not set
 * @prop {string} name - Property key in the value object (should be an array of keys)
 *
 * @example
 * <Transfer
 *   :value="config"
 *   :setting="{
 *     label: 'User Permissions',
 *     detail: 'Select user permissions',
 *     titles: ['Available', 'Granted'],
 *     data: [
 *       { key: 'read', label: 'Read Access' },
 *       { key: 'write', label: 'Write Access' },
 *       { key: 'admin', label: 'Admin Access' }
 *     ]
 *   }"
 *   name="permissions"
 * />
 */
import Tooltip from "../Tooltip.vue";
export default {
  components: { Tooltip },
  props: ["value", "setting", "name"],
  mounted() {
    if (this.value[this.name] == null) {
      if (this.setting.default != null) {
        this.$set(this.value, this.name, this.setting.default);
      } else {
        this.$set(this.value, this.name, null);
      }
    }
  },
};
</script>
